import { Module } from "@/constants";
import { ProjectPeriodConfirmationService } from "@/modules/projects/service/projectPeriodConfirmation";
import { useQuery } from "@tanstack/react-query";

export const projectPeriodConfirmationStatusQueryKey = (
  projectId: string,
  period: string,
) => [Module.ProjectPeriodConfirmations, projectId, period, "status"] as const;

export const useProjectPeriodConfirmationStatus = (
  projectId: string | undefined,
  period: string,
) =>
  useQuery({
    queryKey: projectPeriodConfirmationStatusQueryKey(projectId ?? "", period),
    queryFn: () =>
      ProjectPeriodConfirmationService.getStatus(projectId as string, period),
    enabled: Boolean(projectId) && Boolean(period),
  });
